import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const EditParty = ({ setResponse }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const party = state?.party;

  const [newLoading, setNewLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    gst: '',
  });

  // Pre-fill formData with existing party data
  useEffect(() => {
    if (party) {
      setFormData({
        name: party.name || '',
        mobile: party.mobile || '',
        email: party.email || '',
        address: party.address || '',
        city: party.city || '',
        state: party.state || '',
        pincode: party.pincode || '',
        gst: party.gst || '',
      });
    }
  }, [party]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNewLoading(true);

    try {
      const response = await fetch(`https://api.hargharmart.com/edit-party/${party.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to update party');
      }

      const result = await response.json();
      setResponse({ type: 'success', message: 'Party updated successfully!' });
        setTimeout(() => setResponse(''), 2000);
      navigate('/view-party');
    } catch (error) {
      console.error('Error:', error);
      setResponse({ type: 'error', message: 'Failed to update party.' });
        setTimeout(() => setResponse(''), 2000);
    } finally {
      setNewLoading(false);
    }
  };

  return (
    <>
      <section className="my-4">
        <div className="px-4">
          <div className="d-flex justify-content-between">
            <p className="page-title">Edit Party: {party?.name}</p>
            <button className="close-btn" onClick={() => navigate('/view-party')}>
              Go Back
            </button>
          </div>

          <form onSubmit={handleSubmit} className="bg-white rounded-2 mt-3 row g-3">
            {['name', 'gst', 'mobile', 'email', 'address', 'city', 'state', 'pincode'].map((field) => (
              <div className="col-md-6" key={field}>
                <label className="form-label">
                  {field.charAt(0).toUpperCase() + field.slice(1)}
                </label>
                <input
                  type="text"
                  className="product-control"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  required={field === 'name'}
                />
              </div>
            ))}
                    <div className="col-12 my-3">
            <button type="submit" className="edit-btn float-end">
              Update Details
            </button>
            </div>
          </form>
        </div>
      </section>

      {newLoading && <Loading setLoading={setNewLoading} />}
    </>
  );
};

export default EditParty;
